import _Skeleton from "@mui/material/Skeleton";
import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../../assets/scripts/chart.umd.min.js';
const types = ['single', 'several'];
const typesMap = {
  several: {
    labelKey: 'commons.transport_habits.multimodal.label_several_modes',
    color: '#3E7BDF'
  },
  single: {
    labelKey: 'commons.transport_habits.multimodal.label_single_mode',
    color: '#46CE9D'
  }
};
export function TransportHabitsMultimodal({
  stats
}) {
  const [initialized, setInitialized] = useState(true);
  const canvasRef = useRef(null);
  const {
    t
  } = useTranslation();
  useEffect(() => {
    const {
      Chart,
      DoughnutController,
      ArcElement,
      Tooltip
    } = window.Chart;
    Chart.register(DoughnutController, ArcElement, Tooltip);
    Chart.defaults.font.family = '"Roboto", "Helvetica", "Arial", sans-serif';
    setInitialized(true);
  }, []);
  useEffect(() => {
    let chart;
    if (initialized && stats) {
      const {
        Chart
      } = window.Chart;
      if (canvasRef.current) {
        const {
          respondantsCount,
          respondantsDoingMultimodalCount
        } = stats;
        chart = new Chart(canvasRef.current, {
          type: 'doughnut',
          data: {
            labels: types.map(key => t(typesMap[key].labelKey)),
            datasets: [{
              data: [respondantsCount - respondantsDoingMultimodalCount, respondantsDoingMultimodalCount],
              backgroundColor: types.map(key => typesMap[key].color)
            }]
          },
          options: {
            cutout: '80%',
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
              title: {
                display: false
              },
              tooltip: {
                callbacks: {
                  label: ({
                    parsed: count
                  }) => ` ${t('commons.transport_habits.respondents', {
                    count
                  })}`
                }
              }
            }
          }
        });
      }
    }
    return () => chart?.destroy();
  }, [initialized, stats]);
  return /*#__PURE__*/React.createElement(_Box, {
    bgcolor: "#fff",
    borderRadius: 2,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: 3,
    height: "100%",
    padding: 3
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontSize: "1.1rem",
    fontWeight: 600
  }, t('commons.transport_habits.multimodal.title')), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: 200
  }, stats ? /*#__PURE__*/React.createElement(_Box, {
    component: "canvas",
    height: "100%",
    id: "chart",
    ref: canvasRef,
    width: "100%"
  }) : /*#__PURE__*/React.createElement(_Skeleton, {
    height: 200,
    variant: "circular",
    width: 200
  })), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, types.map(key => {
    const {
      color,
      labelKey
    } = typesMap[key];
    return /*#__PURE__*/React.createElement(_Box, {
      alignItems: "flex-start",
      display: "flex",
      gap: 2,
      key: key
    }, /*#__PURE__*/React.createElement(_Box, {
      paddingTop: 1
    }, /*#__PURE__*/React.createElement(_Box, {
      bgcolor: color,
      borderRadius: 3,
      flexShrink: 0,
      height: 10,
      width: 10
    })), /*#__PURE__*/React.createElement(_Box, {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1
    }, /*#__PURE__*/React.createElement(_Typography, {
      variant: "body2"
    }, t(labelKey)), /*#__PURE__*/React.createElement(_Typography, {
      noWrap: true,
      fontSize: "1.1rem",
      fontWeight: 600
    }, stats ? `${Math.round((key === 'single' ? (stats.respondantsCount - stats.respondantsDoingMultimodalCount) / stats.respondantsCount : stats.respondantsDoingMultimodalCount / stats.respondantsCount) * 100)} %` : /*#__PURE__*/React.createElement(_Skeleton, {
      variant: "text",
      width: 100
    }))));
  })));
}